import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { environment } from 'src/environments/environment';
import { ValorDaObraService } from '../modal-mais-filtros-imobiliario/service/valorObra/valor-da-obra.service';

interface ValorObra {
  id: number;
  description: string;
}

@Component({
  selector: 'app-filtro-valor-obra',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-valor-obra.component.html',
  styleUrl: './filtro-valor-obra.component.scss',
})
export class FiltroValorObraComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  dataValorObraDe: ValorObra[] = [];
  dataValorObraAte: ValorObra[] = [];

  @Input() idModuloSelecionado: number;
  @Input() valorInicial: { de: number | null; ate: number | null } | null = null;
  @Output() valorObraChange = new EventEmitter<{
    de: number | null;
    ate: number | null;
  }>();

  valorDeSelecionado: number | null = null;
  valorAteSelecionado: number | null = null;

    @Input() disabled: boolean = false;


  private readonly _valorDaObraService: ValorDaObraService =
    inject(ValorDaObraService);
  private jaCarregou = false;

  ngOnInit() {

  }

  ngOnChanges(changes?: SimpleChanges) {
    if (changes?.['valorInicial'] && this.valorInicial) {
      this.valorDeSelecionado = this.valorInicial.de ?? null;
      this.valorAteSelecionado = this.valorInicial.ate ?? null;
    }
    if (changes?.['idModuloSelecionado'] || !this.jaCarregou) {
      this.jaCarregou = true;
      this.montaArraysValorDaObra();
    }
  }

  montaArraysValorDaObra() {
    this._valorDaObraService.valorDe().subscribe({
      next: (data: ValorObra[]) => {
        this.dataValorObraDe = data;
      },
      error: (err) => {
        console.error('Erro ao carregar valores "De" (Valor da Obra):', err);
      },
    });

    this._valorDaObraService.valorAte().subscribe({
      next: (data: ValorObra[]) => {
        this.dataValorObraAte = data;
      },
      error: (err) => {
        console.error('Erro ao carregar valores "Até" (Valor da Obra):', err);
      },
    });
  }

  onValorDeChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.valorDeSelecionado = value ? Number(value) : null;
    this.emitValorObraChange();
  }

  onValorAteChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.valorAteSelecionado = value ? Number(value) : null;
    this.emitValorObraChange();
  }

  emitValorObraChange() {
    this.valorObraChange.emit({
      de: this.valorDeSelecionado,
      ate: this.valorAteSelecionado,
    });
  }
}
